var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tag',{staticClass:"tower-tag",attrs:{"color":_vm.colorProp}},[_c('a',{attrs:{"href":("/tower/?name=" + _vm.name),"target":"_blank"}},[_vm._v(_vm._s(_vm.title)+" | "+_vm._s(_vm.ratestr))])])}
var staticRenderFns = []

export { render, staticRenderFns }